export default {
  meta: {
    localeModules: [
      'openClaw',
      'daily',
      'aiChat',
      'aiAssistant',
      'researchEditor',
      'cloudDocument',
      'report',
      'summary',
      'aiDataUsage'
    ],
    title: 'routers.ai_chat_ai_jinbao'
  },
  path: '/openClaw',
  component: () => import(/* webpackChunkName: 'openClaw' */ '@/pages/aiAssistant/taskMode/layout.vue'),
  redirect: '/openClaw/openClawChat',
  children: [
    {
      path: 'openClawChat/:chatId?',
      name: 'openClawChat',
      component: () => import('@/pages/aiAssistant/taskMode/index.vue'),
      meta: {
        name: 'openClaw.nav.chat',
        description: 'openClaw.chat.description',
        parent: '/aiChat/index',
        // 任务模式自带完整布局，内/外层面包屑都不展示；与研究模式对齐，
        // 避免从研究模式切入时残留的面包屑显示在任务模式顶部
        hideBreadcrumb: true,
        hideOuterBreadcrumb: true,
        // AI进宝三模式（聊天/研究/任务）共用同一个客户端顶部tab
        tabGroup: '/aiChat/index'
      }
    },
    {
      path: 'settings',
      name: 'settings',
      redirect: '/openClaw/settings/index',
      meta: {
        name: 'openClaw.nav.settings',
        description: 'openClaw.settings.description',
        parent: '/aiChat/index',
        hideBreadcrumb: true
      },
      component: () => import(/* webpackChunkName: 'openClaw' */ '@/pages/aiAssistant/taskMode/settings/index.vue'),
      children: [
        {
          path: 'channels',
          name: 'channels',
          component: () => import('@/pages/aiAssistant/taskMode/control/channels/index.vue'),
          meta: {
            name: 'openClaw.nav.channels',
            description: 'openClaw.channels.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'sessions',
          name: 'sessions',
          component: () => import('@/pages/aiAssistant/taskMode/control/sessions/index.vue'),
          meta: {
            name: 'openClaw.nav.sessions',
            description: 'openClaw.sessions.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'heartbeat',
          name: 'heartbeat',
          component: () => import('@/pages/aiAssistant/taskMode/control/heartbeat/index.vue'),
          meta: {
            name: 'openClaw.nav.heartbeat',
            description: 'openClaw.heartbeat.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'mcp',
          name: 'mcp',
          component: () => import('@/pages/aiAssistant/taskMode/agent/mcp/index.vue'),
          meta: {
            name: 'openClaw.nav.mcp',
            description: 'openClaw.mcp.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'tools',
          name: 'openClawTools',
          component: () => import('@/pages/aiAssistant/taskMode/agent/tools/index.vue'),
          meta: {
            name: 'openClaw.nav.tools',
            description: 'openClaw.tools.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'workspace',
          name: 'workspace',
          component: () => import('@/pages/aiAssistant/taskMode/agent/workspace/index.vue'),
          meta: {
            name: 'openClaw.nav.workspace',
            description: 'openClaw.workspace.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'agent-config',
          name: 'agent-config',
          component: () => import('@/pages/aiAssistant/taskMode/agent/config/index.vue'),
          meta: {
            name: 'openClaw.nav.agentConfig',
            description: 'openClaw.agentConfig.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'models',
          name: 'models',
          component: () => import('@/pages/aiAssistant/taskMode/settings/models/index.vue'),
          meta: {
            name: 'openClaw.nav.models',
            description: 'openClaw.agentConfig.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'environments',
          name: 'environments',
          component: () => import('@/pages/aiAssistant/taskMode/settings/environments/index.vue'),
          meta: {
            name: 'openClaw.nav.environments',
            description: 'openClaw.environments.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'voice-transcription',
          name: 'voiceTranscription',
          component: () => import('@/pages/aiAssistant/taskMode/settings/voiceTranscription/index.vue'),
          meta: {
            name: 'openClaw.nav.voiceTranscription',
            description: 'openClaw.voiceTranscription.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'token-usage',
          name: 'tokenUsage',
          component: () => import('@/pages/aiAssistant/taskMode/settings/tokenUsage/index.vue'),
          meta: {
            name: 'openClaw.nav.tokenUsage',
            description: 'openClaw.tokenUsage.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'security',
          name: 'security',
          component: () => import('@/pages/aiAssistant/taskMode/settings/security/index.vue'),
          meta: {
            name: 'openClaw.nav.security',
            description: 'openClaw.security.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'agents',
          name: 'openClawAgents',
          component: () => import('@/pages/aiAssistant/taskMode/settings/agents/index.vue'),
          meta: {
            name: 'openClaw.nav.agents',
            description: 'openClaw.agents.description',
            hideBreadcrumb: true
          }
        },
        {
          path: 'skillPool',
          name: 'skillPool',
          component: () => import('@/pages/aiAssistant/taskMode/agent/SkillPool/index.vue'),
          meta: {
            name: 'openClaw.skillPool.pageTitle',
            description: 'openClaw.skillPool.pageDescription',
            hideBreadcrumb: true
          }
        }
      ]
    }
  ]
};
